<template>
  <layout kind="one_column">
    <v-container class="fluid pt-0 mt-0 pb-0">
      <v-layout class="row wrap">
        <v-flex class="xs12 pa-4">
          <h1 class="max">{{i18n('Buscar Cadastro')}}</h1>
        </v-flex>
        <v-flex class="xs12 pa-4">
          <transition name="fade">
            <v-card class="mb-3" style="border-radius: 10px;">
              <v-container>
                <v-layout class="row wrap ">
                  <v-flex class="xs12 sm7 py-2 ">
                  </v-flex>
                  <v-flex class="xs12 sm5 py-0 text-xs-left text-sm-right pt-1">
                    <div class="font-weight-thin font-color">{{i18n('Registros')}}: {{companies.length}}</div>
                  </v-flex>
                  <v-flex class="xs12 lg5 pa-0">
                    <h5 class="font-paralucent font-color p-1 text-2xl font-bold">{{i18n('Buscar por')}}:</h5>
                    <v-radio-group v-model="search_mode">
                      
                      <div class="display-flex-baseline">
                        <v-radio :label="i18n('Nome')" value="name_in"></v-radio>
                        <v-radio :label="i18n('Número documento')" value="document_number_prefix"></v-radio>
                        <v-radio :label="i18n('Id cadastro')" value="id"></v-radio>
                      </div>
                    </v-radio-group>
                  </v-flex>
                  <v-flex class="xs12 lg6 ml-5">
                    <div class="hidden-md-and-down">&nbsp;</div>
                    <v-text-field v-model="search_query" class="search-filter" append-icon="search" @keyup.enter="searchCompanies()"></v-text-field>
                  </v-flex>

                  <subject-item :admin="false" @onUpdate="onUpdate" @onReprove="onReprove" :record="company" v-for="company in companies" :key="company.id" />

                  <v-flex class="xs12 pt-0 mt-1" v-if="companiesLoaded == 'empty' || loading">
                    <v-layout class="row wrap">
                      <v-flex class="xs12 py-0">
                        <v-container class="py-3 px-0">
                          <v-layout class="row wrap">
                            <v-flex class="xs12 md8 text-xs-center text-sm-left">
                              <v-layout class="row wrap body-1">
                                <v-flex class="xs12 py-0" v-if="companiesLoaded == 'empty' && !loading">
                                  {{i18n('Nenhum cadastro encontrado')}}
                                </v-flex>
                                <v-flex class="xs12 py-0" v-if="loading">
                                  {{i18n('Buscando cadastros')}}
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-layout class="row wrap pa-3">
                  <v-flex class="xs6">
                    <v-btn block flat class="font-weight-black secondary-btn-bg-color mr-3 " @click="cleanSearch">
                      {{i18n('Limpar busca')}}
                    </v-btn>
                  </v-flex>
                  <v-flex class="xs6">
                    <v-btn block flat class="font-weight-black btn-bg-color ml-2" @click="searchCompanies">
                      {{i18n('Buscar')}}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import CustomersItem from "./CustomersItem"
import Breadcrumb from "./components/Breadcrumb"

export default {
  name: 'CustomersSubjectsSearch',
  components: { layout: LeftBarLayout, 'subject-item': CustomersItem, Breadcrumb},
  data() {
    return {
      companies: [],
      companiesLoaded: 'not_loaded',
      search_query: '',
      search_mode: 'name_in',
      loading: false
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    cleanSearch(e) {
      this.companies = []
      this.companiesLoaded = 'not_loaded'
      this.search_query = ''
    },
    onUpdate(companies, record) {
      if ((record.clearance_level * 1) == 0) {
        companies.splice(companies.findIndex(el => el.id === record.id), 1)
      }
    },
    onReprove(companies, record) {
      companies.splice(companies.findIndex(el => el.id === record.id), 1)
    },
    searchCompanies() {
      if (this.search_query.trim() == '') {
        return false
      }

      let successCallback = (response) => {
        this.loading = false

        if (response.body.data) {
          this.companies = response.body.data

          if (this.companies.length === 0) {
            this.companiesLoaded = 'empty'
          } else {
            this.companiesLoaded = 'ok'
          }
        } else {
          this.companiesLoaded = 'error'
        }
      }

      let errorCallback = (response) => {
        this.loading = false

        if (response.status === 401) {
          this.companiesLoaded = 'not_authorized'
        } else {
          this.companiesLoaded = 'error'
        }
      }

      const mode = this.search_mode
      let s = this.search_query
      if (mode == 'document_number_prefix') {
        const isCpf = /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/.test(s)
        const isCnpj = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/.test(s)
        if (isCpf || isCnpj) {
          s = s.replace(/[^0-9]/g,'')
        }
      }

      this.companies = []
      this.loading = true
      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.customer__search, { params: { s, mode }, headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}

</script>
<style>
.btn-bg-color {
  background-color: var(--secondary-button-background-color) !important;
  color: white !important;
}

.secondary-btn-bg-color{
  color: var(--background-color) !important;
}

.display-flex-baseline{
 display: flex; 
 align-items: baseline;
}

 .font-paralucent {
    font-family: paralucent;
  }
  .p-10 {
    padding: 2.5rem;
  }
  .text-2xl {
    font-size: 1.5rem;
  }
  .font-bold {
    font-style: bold;
  }
  .font-color{
    color: #44517B;
  }
</style>



// WEBPACK FOOTER //
// src/CustomersSubjectsSearch.vue